<template>
  <v-container>
    <v-card class="mx-auto" max-width="512px">
      <v-card-title class="blue-grey white--text">
        <h3>User profile</h3>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="isFormValid" lazy-validation>
          <v-text-field label="Display name" v-model="displayName" prepend-icon="mdi-label" />
          <v-alert dense outlined type="info">
            The password must contain at least 1 upper case letter, 1 lower case letter,
            1 number or special character and 8 characters in length
          </v-alert>
          <v-text-field
            :type="showPassword ? 'text' : 'password'"
            v-model="newPassword"
            :rules="newPasswordRules"
            label="New password (leave empty to keep the existing one)"
            prepend-icon="mdi-lock"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
          />
            <v-text-field
              :type="showPassword ? 'text' : 'password'"
              v-model="newPasswordConfirm"
              :error-messages="newPasswordConfirmErrors"
              label="Confirm new password"
              prepend-icon="mdi-lock"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
            />
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn @click="validate" color="info" :disabled="!isFormValid">
          <v-icon>mdi-content-save</v-icon>Save
        </v-btn>
        <v-btn @click="$emit('close')" color="orange white--text">
          <v-icon>mdi-cancel</v-icon>Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<style scoped>
.v-list-item {
  min-height: 0px;
}
</style>

<script>
export default {
  name: "UserProfile",
  components: {},
  data: () => ({
    isFormValid: false,
    isRemoveFormValid: false,
    newPassword: "",
    newPasswordConfirm: "",
    newPasswordRules: [
      v =>
        /^((?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*)?$/.test(
          v
        ) || "Password must be valid"
    ],
    showPassword: false,
    displayName: ""
  }),
  created() {
    this.displayName = this.$store.getters.userDisplayName;
  },
  computed: {
    newPasswordConfirmErrors() {
      const errors = []
      this.newPasswordConfirm == this.newPassword || errors.push("Password fields didn't match");
      return errors;
    },
  },
  methods: {
    processErrorResponse(result) {
      this.$emit("error", result);
    },
    validate() {
      if (this.$refs.form.validate()) {
        var data = {
          display_name: this.displayName != "" ? this.displayName : null,
        };
        if (this.newPassword != "") {
          data['password'] = this.newPassword;
        }
        this.$axios
          .put("/users/self", data)
          .then(() => {
            this.$store.commit("display_name", this.displayName);
            this.$emit("success", "Profile successfully updated");
            this.close();
          })
          .catch(result => {
            this.processErrorResponse(result);
          });
      }
    },
    close() {
      this.$emit('close');
    },
  }
};
</script>
